import bscPlugin from '@exodus/bsc-plugin';
export const bsc = bscPlugin;
